import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      id="footer"
      className="flex flex-col md:flex-row justify-between gap-2 px-6 md:px-14 py-5 border-t-2 border-gray-300 bg-white"
    >
      <p className="text-gray-400">Made with love by dAirect</p>
      <p
        className="text-base text-gray-400 cursor-pointer"
        onClick={() => navigate("/tos")}
      >
        {t("tos")}
      </p>
      <p
        className="text-base text-gray-400 cursor-pointer"
        onClick={() => navigate("/privacy")}
      >
        {t("privacy")}
      </p>
      <p
        className="text-base text-gray-400 cursor-pointer"
        onClick={() => navigate("/cookie")}
      >
        {t("cookie")}
      </p>
    </div>
  );
};

export default Footer;
